import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Layout, Icon } from 'antd';
import './SubMenuSider.css';
import { Link } from 'react-router-dom';
import classNames from 'classnames'

const { Header, Content } = Layout;

export default class MenuSider extends Component {

    state = { visible: false, name: "User Profile" };

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    render() {
        // var Step1 = classNames({
        //     'active-basic_info': 'active' === this.props.Step1,
        //     'disable-basic_info': 'disable' === this.props.Step1,
        //     'font': true
        // });
        // var Step2 = classNames({
        //     'active-checklist': 'active' === this.props.Step2,
        //     'disable-checklist': 'disable' === this.props.Step2,
        //     'font': true
        // });
        // var Step3 = classNames({
        //     'active-action': 'active' === this.props.Step3,
        //     'disable-action': 'disable' === this.props.Step3,
        //     'font': true
        // });
        // var Step4 = classNames({
        //     'active-summary': 'active' === this.props.Step4,
        //     'disable-summary': 'disable' === this.props.Step4,
        //     'font': true
        // });
        return (
            <div>
                <Layout>
                    <Header style={{ background: 'rgb(0,152,139)', padding: 0, overflow: "hidden" }}>
                        {/* fontFamily: "'Mirza', cursive" */}
                        <div className="topic" style={{ width: "100%", float: "left", textAlign: "center" }}>
                            <div style={{ width: "100%", display: "inline-block", textAlign: "left" }}>
                                <Link to={{ pathname: this.props.path, state: { back: this.props.back } }} style={{ left: "10px", fontSize: "14px", marginLeft: "10px" }}><Icon type="left" theme="outlined" style={{ color: "#CCCCCC" }} /></Link>
                                <span style={{ fontSize: "18px", marginLeft: "10px", color: "white", textAlign: "center" }}>{this.props.title}</span>

                                {/* แถบไอคอน */}
                                {/* <span style={{ float: "right", marginLeft: "5px", marginRight: "10px" }}><Icon type="check-circle" className={Step4} style={{ borderRadius: "15px" }} /></span>
                                <span style={{ float: "right", marginLeft: "5px" }}><Icon type="issues-close" className={Step3} style={{ borderRadius: "15px" }} /></span>
                                <span style={{ float: "right", marginLeft: "5px" }}><Icon type="question-circle" className={Step2} style={{ borderRadius: "15px" }} /></span>
                                <span style={{ float: "right", marginLeft: "5px" }}><Icon type="info-circle" className={Step1} style={{ borderRadius: "15px" }} /></span> */}

                            </div>
                        </div>
                    </Header>
                    <Content
                        style={{
                            // margin: "24px 12px",
                            background: "#FFF",
                            minHeight: window.innerHeight - 50,
                        }}
                    >
                        <div>
                            {this.props.children}
                        </div>
                    </Content>
                </Layout>
            </div>
        );
    }
}
